import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["trigger", "placement", "offset", "arrowOffset", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Popover } from '../../Popover';
import { ColorPickerPanel } from './Panel';
export var ColorPicker = function ColorPicker(props) {
  var _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
    placement = props.placement,
    offset = props.offset,
    arrowOffset = props.arrowOffset,
    children = props.children,
    extra = _objectWithoutProperties(props, _excluded);
  return React.createElement(Popover, {
    trigger: trigger,
    offset: offset,
    arrowOffset: arrowOffset,
    placement: placement,
    getPopper: function getPopper() {
      return React.createElement(ColorPickerPanel, _objectSpread({}, extra));
    }
  }, children);
};